import "./i18n";
import { COMPANIES_LIST as BASE_COMPANIES_LIST, COMPANIES_CREATE as BASE_COMPANIES_CREATE, COMPANIES_EDIT as BASE_COMPANIES_EDIT, COMPANIES_VIEW as BASE_COMPANIES_VIEW, } from "./config/routes";
import { UserRole } from "@root/api.types";
export const COMPANIES_LIST = {
    ...BASE_COMPANIES_LIST,
};
export const COMPANIES_CREATE = {
    ...BASE_COMPANIES_CREATE,
    roles: [UserRole.ADMIN],
};
export const COMPANIES_EDIT = {
    ...BASE_COMPANIES_EDIT,
    roles: [UserRole.ADMIN],
};
export const COMPANIES_VIEW = {
    ...BASE_COMPANIES_VIEW,
};
